import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/advantages-of-the-video-chatbot/PageContent.tsx");
